@if (showTabs) {
  <div class="flex pt-6 justify-between items-center border-b">
    <div>
      <ngx-skeleton-loader
        [ngClass]="{ invisible: !showFilters }"
        [theme]="{ height: '54px', width: '100px', marginRight: '8px' }"
        appearance="line"
        count="2"
      />
    </div>
    <div>
      <ngx-skeleton-loader
        [theme]="{ height: '34px', width: '240px' }"
        appearance="line"
      />
    </div>
  </div>
}
@if (showFilters) {
  <div class="flex pt-4 test-filter-block">
    <ngx-skeleton-loader
      [theme]="{ height: '34px', width: '130px', marginRight: '8px' }"
      appearance="line"
      count="3"
    />
  </div>
}
<div class="pt-4">
  @for (col of tableRowsCount; track $index) {
    <div class="pb-1 test-table-row">
      <ngx-skeleton-loader
        [theme]="{ height: '34px', width: '30%', marginBottom: '0' }"
        appearance="line"
      />
      <ngx-skeleton-loader
        [theme]="{ height: '34px', width: '15%', marginBottom: '0' }"
        appearance="line"
        count="3"
      />
      <ngx-skeleton-loader
        [theme]="{ height: '34px', width: '25%', marginBottom: '0' }"
        appearance="line"
      />
    </div>
  }
</div>
